class ConfirmationModal {
  constructor() {
    this.modal = document.createElement("div");
    this.modal.style.cssText = `
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,0.5);
      display: none;
      align-items: center;
      justify-content: center;
      z-index: 9999;
    `;

    const box = document.createElement("div");
    box.style.cssText = `
      background: #ffffff;
      padding: 24px;
      border-radius: 8px;
      max-width: 360px;
      width: 100%;
      text-align: center;
      font-family: Arial, sans-serif;
    `;

    const message = document.createElement("p");
    message.innerText = "Are you sure you want to cancel this coffee request?";
    message.style.marginBottom = "20px";
    message.style.fontSize = "20px";

    const btnWrapper = document.createElement("div");
    btnWrapper.style.display = "flex";
    btnWrapper.style.justifyContent = "space-between";
    btnWrapper.style.gap = "12px";

    const cancelBtn = document.createElement("button");
    cancelBtn.innerText = "Cancel";
    cancelBtn.style.cssText = `
      flex: 1;
      padding: 10px;
      border: 1px solid #ccc;
      background: #fff;
      cursor: pointer;
      font-weight: 600;
    `;

    const confirmBtn = document.createElement("button");
    confirmBtn.innerText = "Continue";
    confirmBtn.style.cssText = `
      flex: 1;
      padding: 10px;
      border: 1px solid #000;
      background: #000;
      color: #fff;
      cursor: pointer;
      font-weight: 600;
    `;

    btnWrapper.appendChild(cancelBtn);
    btnWrapper.appendChild(confirmBtn);

    box.appendChild(message);
    box.appendChild(btnWrapper);
    this.modal.appendChild(box);
    document.body.appendChild(this.modal);

    this.cancelBtn = cancelBtn;
    this.confirmBtn = confirmBtn;
  }

  open(onConfirm) {
    this.modal.style.display = "flex";

    this.confirmBtn.onclick = () => {
      this.close();
      onConfirm?.();
    };

    this.cancelBtn.onclick = () => {
      this.close();
    };
  }

  close() {
    this.modal.style.display = "none";
  }
}

class RequestCoffee {
  constructor(baseURL) {
    this.baseURL = baseURL || "";

    // this.customerEmail = document.getElementById("customerEmail")?.value || null;
    this.customerId = document.getElementById("customerId").value;
    this.customerEmail = document.getElementById("customerEmail").value;
    this.customerName = document.getElementById("customerName").value;

    this.subSelectEle = document.getElementById("subscriptions-select-coffee-request")||null;
    this.coffeeSelectEle = document.getElementById("coffees-selection-coffee-request") || null;
    this.coffeeSelectEle2 = document.getElementById("coffees-selection-coffee-request-2") || null;
    this.coffeeSelectEle3 = document.getElementById("coffees-selection-coffee-request-3") || null;
    this.coffeeSelectEle4 = document.getElementById("coffees-selection-coffee-request-4") || null;
    this.submitBtn = document.getElementById("submit-btn") || null;

    this._subscriptions = [];
    this._coffees = [];

    this.confirmationModal = new ConfirmationModal();

    /* ---------- CONFIG ---------- */
    this.TABLE_STYLES = {
      headerBg: "#004d26",
      headerText: "#fff",
      bodyText: "#333333",
      rowBorder: "#eeeeee",
      buttonText: "#000000",
      buttonBorder: "#000000",
    };

    /**
     * calling the init
     */
    this.init();
  }

  async init() {
    const loader = new loaderCl();
    try {
      loader.showLoader();
      /**
       * attaching handler to the @subscriptionSelectElement
       */
      this.attachOnChangeHandler("sub");
      this.attachOnChangeHandler("coffee");
      this.attachOnChangeHandler("submit");

      // fetch the subscription list base on the customerEmail or customerId
      const data = await this.fetchValidSubscriptionList();

      if (!data) return;

      // call populate method to populate a list of subscriptionId based on result of subscription-list api
      this.populateSubscriptionsOptions();
    } catch (error) {
      // log the catched error
    } finally {
      loader.hideLoader();
    }
  }

  /**
   * to fetch subscriptions list based on customerId
   */
  async fetchValidSubscriptionList() {
    try {
      const response = await fetch(`${this.baseURL}/api/valid-subscriptions`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          customerId: this.customerId,
        }),
      });

      if (!response.ok) {
        const errorObj = await response.json().catch(() => null);
        throw new Error(errorObj?.message || "Failed to fetch subscriptions");
      }

      const data = await response.json();

      /**
       * if there is no any active subscriptions then show error message
       */
      if (!data.data || !data.data?.length) {
        const SubNotFoundContent = `
          <div class="innerContainer">
            <h2 class="request-coffee-title">Make a Coffee Request</h2>

            <div style="
              max-width: 420px;
              margin: 40px auto;
              padding: 24px;
              background-color: transparent;
              border-radius: 8px;
              font-family: var(--VulfSans-family) !important;
              text-align: center;
            ">
              <p class="request-coffee-description">
                Sorry you do not seem to have an active single origin coffee plan.
                Here are some options:
              </p>

              <a href="${window.location.origin}/collections/subscriptions"
                style="
                  display: block;
                  text-decoration: none;
                  border: 2px solid #8c7a5a;
                  color: #000;
                  padding: 25px;
                  margin-bottom: 16px;
                  border-radius: 6px;
                  font-size: 20px;
                  font-family: var(--VulfSans-family) !important;
                  font-weight: 600;
                  background-color: transparent;
                ">
                Start New Subscription
              </a>

              <a href="${window.location.origin}/apps/subscriptions"
                style="
                  display: block;
                  text-decoration: none;
                  border: 2px solid #8c7a5a;
                  color: #000;
                  padding: 25px;
                  margin-bottom: 16px;
                  border-radius: 6px;
                  font-size: 20px;
                  font-family: var(--VulfSans-family) !important;
                  font-weight: 600;
                  background-color: transparent;
                ">
                Reactivate Old Plan
              </a>

              <a href="${window.location.origin}/collections/coffees"
                style="
                  display: block;
                  text-decoration: none;
                  border: 2px solid #8c7a5a;
                  color: #000;
                  padding: 25px;
                  border-radius: 6px;
                  font-size: 20px;
                  font-family: var(--VulfSans-family) !important;
                  font-weight: 600;
                  background-color: transparent;
                ">
                Buy Single Bags
              </a>
            </div>
          </div>
        `;

        /**
         * override the content of  `subscriptionSiteContainer`
         */
        const subContainer = document.getElementById(
          "subscriptionSiteContainer",
        );
        if (subContainer) {
          subContainer.innerHTML = SubNotFoundContent;
        }

        /**
         * hide the available-coffee-list from DOM
         */
        document.getElementById("available-coffee-list")?.remove();

        return;
        // this.showMessage("Subscriptions not found.","error");
      }

      this._subscriptions = data.data;
      return data.data;
    } catch (error) {
      throw new Error(error.message ?? "Failed to fetch subscription list");
    }
  }

  /**
   * to fetch coffees list based on selected subscriptionId
   */
  async fetchCoffeeProfileList(subscriptionId) {
    try {
      const response = await fetch(`${this.baseURL}/api/coffees-list`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          subscriptionId: subscriptionId,
          customerEmail: this.customerEmail,
        }),
      });

      if (!response.ok) {
        const errorObj = await response.json().catch(() => null);
        throw new Error(errorObj?.message || "Failed to fetch coffee list");
      }

      const data = await response.json();

      /**
       *  render table
       */
      this.createAndUpdateTable(data.requestedCoffees ?? []);

      this._coffees = data.data;

      /**
       * check if subscription for 2lbs then inject second coffee-select for this subscription
       * else delete the existing second select for the coffee
       */

      if(data.size != null){
        this.addSecondCoffeeSelect(data.size);
      }else{
        this.removeSecondCoffeeSelect();
      }

      /**
       * update group label
       */
      this.updateCoffeeLabel(data.size);
    } catch (error) {
      throw new Error(error.message ?? "Failed to fetch subscription list");
    }
  }

  addSecondCoffeeSelect(size){
    /**
     * base for value for extrac coffee select options
     */
    const counter = 2;
    for (let i=0; i < Number(size)-1; i++){
      const idIndex = counter + i;

      if(!!document.getElementById(
      `coffees-selection-coffee-request-${idIndex}`
      )) continue;

      /**
       * fetching form-container
       */
      const formContainer = document.querySelector(".form-container");

      /**
       * fetching the submitButton element
       */
      const submitBtn = document.querySelector(".submitBtnMian");

      /**
       * creating form-group element
       */
      const formGroup = document.createElement("div");
      formGroup.className="form-group";
      formGroup.id=`coffee-request-${idIndex}`;

      /**
       * inject html-select element to it
       */
      formGroup.innerHTML = `
        <label for="coffees-selection-coffee-request-${idIndex}">Request a coffee (Bag ${idIndex})</label>
        <select id="coffees-selection-coffee-request-${idIndex}"></select>
        `;

      /**
       * injecting this second coffee-select to the DOM, before the submit button
       */
      formContainer.insertBefore(formGroup,submitBtn);

      switch (idIndex) {
        case 2:
          this.coffeeSelectEle2 = document.getElementById(
            `coffees-selection-coffee-request-${idIndex}`
          );
          break;
        case 3:
          this.coffeeSelectEle3 = document.getElementById(
            `coffees-selection-coffee-request-${idIndex}`
          );
          break;
        case 4:
          this.coffeeSelectEle4 = document.getElementById(
            `coffees-selection-coffee-request-${idIndex}`
          );
          break;
        default:
          break;
      }
    }
    /**
     * to remove extra coffee select options if exists
     */
    this.removeSecondCoffeeSelect(size);
  };

  /**
   * to remove some or all extrac offee select options
   */
  removeSecondCoffeeSelect(sizeToKeep){
    const maxNumberOfNodesToRemove = 3;
    const counter = 2;

    for(let i = 0; i < maxNumberOfNodesToRemove; i++){
      const idIndex = counter + i;

      if(sizeToKeep && idIndex > sizeToKeep ){
        this.removeASelectNode(idIndex);
      }
      
      if(!sizeToKeep){
        this.removeASelectNode(idIndex);
      }
    };
  };

  /**
   * to remove a specific coffee select node
   */
  removeASelectNode(index){
    document.getElementById(`coffee-request-${index}`)?.remove();

    switch (index) {
      case 2:
        this.coffeeSelectEle2 = null;
        break;
      case 3:
        this.coffeeSelectEle3 = null;
        break;
      case 4:
        this.coffeeSelectEle4 = null;
        break;
      default:
        break;
    }
  }

  updateCoffeeLabel(is2lbsSub) {
    const label = document.querySelector(
      'label[for="coffees-selection-coffee-request"]',
    );

    if (!label) return;

    if (is2lbsSub !== null) {
      label.textContent = "Request a coffee (Bag 1)";
    } else {
      label.textContent = "Request a coffee";
    }
  }

  /**
   * @populateSubscriptionsOptions to populate subscriptionOption
   */
  populateSubscriptionsOptions() {
    this._subscriptions?.forEach((opt, index) => {
      const option = document.createElement("option");
      option.value = opt.subscriptionId;
      option.textContent = `${opt.subscriptionId}`;
      if (index === 0) option.selected = true;
      this.subSelectEle.appendChild(option);
    });

    /**
     * dispatching the new 'change' event for default first selected item
     */
    if (this._subscriptions?.length) {
      this.subSelectEle.dispatchEvent(new Event("change"));
    }
  }

  populateCoffeesOptions() {
    this.coffeeSelectEle.innerHTML = "";

    /**
     * Clearing all selects
     */
    const selects = [
      this.coffeeSelectEle,
      this.coffeeSelectEle2,
      this.coffeeSelectEle3,
      this.coffeeSelectEle4
    ];
    
    selects.filter(Boolean).forEach(select => {
      select.innerHTML = "";
    });


    /**
     * Adding placeholder only to secondary selects
     */
    [this.coffeeSelectEle2, this.coffeeSelectEle3, this.coffeeSelectEle4]
      .filter(Boolean)
      .forEach((select,i) => {
        let selectNum = "SECOND";
        
        switch(2+i){
          case 3:
            selectNum = "THIRD";
            break;
          case 4:
            selectNum = "FOURTH";
            break;
          default:
        };

        const placeholder = document.createElement("option");
        placeholder.value = "";
        placeholder.textContent = `SELECT ${selectNum} COFFEE`;
        placeholder.disabled = true;
        placeholder.selected = true;
        select?.appendChild(placeholder);
      });


    /**
     * Populate options
     */
    this._coffees?.forEach((coffee, index) => {
      const option = document.createElement("option");
      option.value = coffee.id;
      option.textContent = coffee.title;

      if (index === 0 && this.coffeeSelectEle) {
        option.selected = true;
      }

      /**
       * Append to all selects (clone for safety)
       */
      selects.forEach(select => {
        select?.appendChild(option.cloneNode(true));
      });
    });

    // if (this.coffeeSelectEle2) {
    //   this.coffeeSelectEle2.selectedIndex = -1;
    // }
  };

  populateCoffeesOptionsFromCollection(allProducts){
    allProducts.forEach((cardProduct)=>{
      console.log(cardProduct);
      const productNameWithouTag = cardProduct.name.slice(0,cardProduct.name.indexOf("(")).trim().toLowerCase();
      const productId = `gid://shopify/Product/${cardProduct.id}`;

      const isCoffeeExist = this._coffees?.some((coffee) => {
        return (
          coffee.id == productId ||
          coffee.title.toLowerCase().includes(productNameWithouTag)
        );
      });

      if (!isCoffeeExist) {
        const option = document.createElement("option");
        option.value = `gid://shopify/Product/${cardProduct.id}`;
        option.textContent = `${cardProduct.name}`;

        this._coffees?.push({
          title: cardProduct.name,
          id: `gid://shopify/Product/${cardProduct.id}`,
        });

        this.coffeeSelectEle.appendChild(option);
        this.coffeeSelectEle2?.appendChild(option.cloneNode(true));
      }
    });

    //FORCE reset AFTER everything is appended
    if (this.coffeeSelectEle2) {
      this.coffeeSelectEle2.value = "";
    }
  }

  /**
   *@attachOnChangeHandler to add attach eventListener to selection element
   *@handleTo - type to which eventListener will be attached
   */
  async attachOnChangeHandler(handleTo) {
    if (handleTo === "sub") {
      this.subSelectEle.addEventListener("change", async (evt) => {
        await this.handleSubSelection(evt.target.value);
      });
    } else if (handleTo === "coffee") {
      this.coffeeSelectEle.addEventListener("change", async (evt) => {
        // nothing
      });
    } else if (handleTo === "submit") {
      this.submitBtn?.addEventListener("click", async () => {
        await this.handleSubmit();
      });
    }
  }

  /**
   *@handleSubSelection to fetch the coffees list on select subscription
   */
  async handleSubSelection(subId) {
    this.hideAlert();
    const loader = new loaderCl();
    try {
      loader.showLoader();
      await this.fetchCoffeeProfileList(subId);

      /**
       * populating options
       */
      this.populateCoffeesOptions();
      /**
       * render the cards for each coffees
       */
      await this.listProducts(subId);
    } catch (error) {
      console.log(error);
    } finally {
      loader.hideLoader();
    }
  }

  async listProducts(subId) {
    try {
      document.querySelector("#product-grid-request-coffee").innerHTML = "";

      const groups = this._subscriptions?.find(
        (s) => s.subscriptionId === subId,
      )?.groups;

      const allProducts = [];

      const results = await Promise.all(
        groups.map(async (group) => {
          const res = await fetch(
            `/collections/${group}?view=driftaway-request-coffees`,
          );
          const html = await res.text(); // just return the HTML

          // Parse HTML safely
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          // Select all matching cards
          const cards = doc.querySelectorAll(
            ".card-wrapper.product-card-wrapper.underline-links-hover",
          );

          // Wrap each card in an extra div, without removing other tags
          cards.forEach((card) => {
            // -------------------------------------------------------
            // Extract product NAME
            // -------------------------------------------------------
            const titleElement =
              card.querySelector(".card__heading a") ||
              card.querySelector(".full-unstyled-link") ||
              card.querySelector("a");

            const productName = titleElement?.textContent?.trim() ?? null;

            // -------------------------------------------------------
            // Extract product ID from URL
            // -------------------------------------------------------
            const href = titleElement?.getAttribute("href");

            let productId = null;
            const linkIdAttr = titleElement?.getAttribute("id");
            if (linkIdAttr && linkIdAttr.includes("--")) {
              productId = linkIdAttr.split("--")[1];
            }


            // Save extracted info
            allProducts.push({
              name: productName,
              id: productId,
            });

            const wrapper = doc.createElement("li");
            wrapper.classList.add(
              "grid__item",
              "scroll-trigger",
              "animate--slide-in",
            );
            card.replaceWith(wrapper);
            wrapper.appendChild(card);
          });

          // Return the full modified HTML (everything preserved)
          return doc.body.innerHTML;
        }),
      );

      /**
       * @populateCoffeesOptionsFromCollection not required
       *  here coming from backend
       */
      // this.populateCoffeesOptionsFromCollection(allProducts);

      // Combine all HTMLs and insert once
      const allCardProducts = results.join("");
      document.querySelector("#product-grid-request-coffee").innerHTML =
        allCardProducts;
      document.dispatchEvent(new Event("shopify:section:load"));
    } catch (error) {
      console.log(error);
    }
  }

  async handleSubmit() {
    const loader = new loaderCl();
    this.hideAlert();
    try {
      loader.showLoader();

      const selectedSubId = this.subSelectEle.value;
      const selectedCoffeeId = this.coffeeSelectEle.value;
      const selectedCoffeeId2 = this.coffeeSelectEle2?.value;
      const selectedCoffeeId3 = this.coffeeSelectEle3?.value;
      const selectedCoffeeId4 = this.coffeeSelectEle4?.value;

      const requestedCoffeesToBeAdded = [];

      /**
       * preparing list of requested coffees
       */
      [selectedCoffeeId,selectedCoffeeId2,selectedCoffeeId3,selectedCoffeeId4].filter(Boolean).forEach((sCId)=>{
        /**
         * finding coffee from list base on selected coffee id
         */
        const selectedCoffee = this._coffees.find((cf) => cf.id == sCId);

        /**
         * extract id
         */
        const coffeeId = selectedCoffee.id?.split("/")?.pop();

        /**
         * format coffee name with coffee id
         */
        const coffeeName = `${selectedCoffee.title} ${coffeeId ? `(${coffeeId})` : ""}`;

        /**
         * add requeste-coffee-data to the list
         */
        requestedCoffeesToBeAdded.push({
          customerEmailId: this.customerEmail,
          coffeeName: coffeeName,
          subscriptionId: selectedSubId,
          customerName: this.customerName,
          productImageUrl: selectedCoffee?.featuredMedia?.image?.url,
          productUrl: selectedCoffee?.onlineStorePreviewUrl,
          coffeeRequestPageUrl: window.location.href,
          status: 0,
        });
      });

      
      if(this.coffeeSelectEle4 && requestedCoffeesToBeAdded?.length < 4){
        throw Error("Please select all four coffees.");
      }

      if(this.coffeeSelectEle3 && requestedCoffeesToBeAdded?.length < 3){
        throw Error("Please select all three coffees.");
      }
      
      if(this.coffeeSelectEle2 && requestedCoffeesToBeAdded?.length < 2){
        throw Error("Please select all two coffee.");
      }

      if(!requestedCoffeesToBeAdded.length){
        throw Error("Coffee not selected");
      };
      
      
      /**
       * Calling Update Request Coffee API
       */
      const res = await this.updateCoffeeRequestData(requestedCoffeesToBeAdded);

      this.showMessage(
        "All set — your coffee request is in! We’ll email you to confirm soon.",
        "success",
      );

      await this.fetchCoffeeProfileList(selectedSubId);

      /**
       * populating options
       */
      this.populateCoffeesOptions();

      /**
       * render the cards for each coffees
       */
      await this.listProducts(selectedSubId);

      if (this.coffeeSelectEle) {
        this.coffeeSelectEle.value = selectedCoffeeId;
      }

      if (this.coffeeSelectEle2) {
        this.coffeeSelectEle2.value = selectedCoffeeId2;
      }

      if(this.coffeeSelectEle3){
        this.coffeeSelectEle3.value= selectedCoffeeId3;
      }

      if(this.coffeeSelectEle4){
        this.coffeeSelectEle4.value= selectedCoffeeId4;
      }

    } catch (error) {
      this.showMessage(
        error.message || "Failed to add coffee request",
        "error",
        true,
      );
    } finally {
      loader.hideLoader();
    }
  }

  async updateCoffeeRequestData(data) {
    try {
      const response = await fetch(`${this.baseURL}/api/add-requested-coffee`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          requestedCoffees: data,
          shouldSendEmail: true,
        }),
      });

      /**
       * error handling
       */
      if (!response.ok) {
        const errorObj = await response.json().catch(() => null);
        throw new Error(errorObj?.message || "Failed to request coffee");
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  }

  showMessageForTwoPounds() {
    const messageContainer = document.querySelector(".customer-message");
    if (!messageContainer) return;

    messageContainer.setAttribute(
      "style",
      `
      color:rgb(241, 11, 11); //#856404
      `,
    );

    this.hideAlert();

    messageContainer.textContent =
      "If you have a 2 lb plan, please submit multiple coffee requests - one request per bag.";
  }

  showMessage(message, type = "info", asHTML = false) {
    const messageContainer = document.querySelector(".customer-message");
    console.log(messageContainer, message);
    if (!messageContainer) return;

    const styles = {
      info: {
        background: "#cce5ff",
        color: "#004085",
        border: "1px solid #004085",
      },
      success: {
        background: "#d4edda",
        color: "#006838",
        border: "1px solid #006838",
      },
      warning: {
        background: "#fff3cd",
        color: "#856404",
        border: "1px solid #856404",
      },
      error: {
        background: "#f8d7da",
        color: "#721c24",
        border: "1px solidrgb(252, 1, 26)",
      },
    };

    messageContainer.setAttribute(
      "style",
      `
      color: ${styles[type]?.color ?? ""} !important;
      `,
    );

    this.hideAlert();

    if (asHTML) {
      messageContainer.innerHTML = message;
    } else {
      messageContainer.textContent = message;
    }
  }

  hideAlert() {
    const messageContainer = document.querySelector(".customer-message");
    if (!messageContainer) return;

    messageContainer.innerHTML = "";
  }

  createSubscriptionTable(containerId) {
    const container = document.getElementById(containerId);
    if (!container) return;

    const isTableExist = document.getElementById("subscription-table");
    if (isTableExist) return;

    /**
     * creating Title for Table
     */
    const tableTitle = document.createElement("h3");
    tableTitle.innerText = "YOUR REQUESTED COFFEES";
    tableTitle.style.fontSize = "clamp(16px, 6vw, 25px)"; // More aggressive scaling
    tableTitle.style.setProperty("color", "#000", "important");
    tableTitle.style.textAlign = "center"; // Center on very small screens

    /**
     * creating Scrollable Table Container
     */
    const tableContainer = document.createElement("div");
    tableContainer.id = "subscription-table-container";
    tableContainer.style.maxHeight = "600px"; // Set your desired max height
    tableContainer.style.overflowY = "auto"; // Enable vertical scrolling
    tableContainer.style.overflowX = "auto";
    tableContainer.style.borderRadius = "10px";
    tableContainer.style.boxShadow = "0 0 0 1px #ddd";
    tableContainer.style.position = "relative"; // For sticky header
    tableContainer.style.minWidth = "280px"; // Reduced for very small screens
    tableContainer.style.margin = "0 -5px"; // Negative margin for better use of space
    tableContainer.style.width = "calc(100% + 10px)"; // Compensate for negative margin
    tableContainer.style.WebkitOverflowScrolling = "touch";
    tableContainer.style.fontSize = "clamp(12px, 3.5vw, 16px)"; // Base font scaling

    // Mobile-specific styles
    tableContainer.style.minWidth = "300px"; // Minimum width for mobile
    tableContainer.style.WebkitOverflowScrolling = "touch"; // Better scrolling on iOS

    /**
     * creating Table
     */
    const table = document.createElement("table");
    table.id = "subscription-table";
    table.style.width = "100%";
    table.style.minWidth = "650px"; // Slightly reduced for very small screens
    table.style.borderCollapse = "collapse";
    table.style.fontFamily = "Arial, sans-serif";
    table.style.overflow = "hidden";
    table.style.borderRadius = "10px";
    table.style.boxShadow = "0 0 0 1px #ddd";
    table.style.tableLayout = "fixed"; // For consistent column widths

    /* ----- HEADER ----- */
    const thead = document.createElement("thead");

    // Make header sticky when scrolling
    thead.style.position = "sticky";
    thead.style.top = "0";
    thead.style.zIndex = "10";

    const headerRow = document.createElement("tr");
    headerRow.style.overflow = "hidden";
    // headerRow.style.borderBottom = "2px solid #ddd";
    headerRow.style.backgroundColor = this.TABLE_STYLES.headerBg;

    //const columnWidths = ["25%", "30%", "25%", "20%"]; // Define column widths
    // Responsive column widths
    const smallScreenWidths = ["60px", "100px", "60px", "60px"]; // Very compact for < 401px

    [
      "Subscription ID",
      "Requested Coffee",
      "Next Shipping Date",
      "Action",
    ].forEach((text, index, arr) => {
      const th = document.createElement("th");
      th.innerText = text.toUpperCase();
      th.style.textAlign = "left";
      th.style.padding = "16px 12px";
      th.style.fontSize = "clamp(12px, 3vw, 18px)";
      th.style.fontWeight = "600";
      th.style.color = this.TABLE_STYLES.headerText;
      th.style.position = "sticky";
      th.style.top = "0";
      th.style.width = smallScreenWidths[index] || "100px"; // Set column width

      th.setAttribute("data-column", text.toLowerCase().replace(" ", "-"));

      if (index === 0) {
        th.style.borderTopLeftRadius = "10px";
      }
      if (index === arr.length - 1) {
        th.style.borderTopRightRadius = "10px";
      }

      headerRow.appendChild(th);
    });

    thead.appendChild(headerRow);
    table.appendChild(thead);

    /* ----- BODY ----- */
    const tbody = document.createElement("tbody");
    table.appendChild(tbody);

    // Put table inside the scrollable container
    tableContainer.appendChild(table);

    container.appendChild(tableTitle);
    container.appendChild(tableContainer);

    // Add CSS media queries via JavaScript
    this.addResponsiveStyles();
    this.enableMobileCardLayout();
  }

  addSubscriptionRow(cells, id) {
    const tbody = document.querySelector("#subscription-table tbody");
    if (!tbody) return;

    const row = document.createElement("tr");
    row.style.borderBottom = `1px solid ${this.TABLE_STYLES.rowBorder}`;

    const rowIndex = tbody.children.length;
    row.style.backgroundColor = rowIndex % 2 === 0 ? "#ffffff" : "#f6f7f8"; //"#f6f7f8";

    // const baseCellStyle = `
    //   padding: 18px 12px;
    //   font-size: 16px;
    //   color: ${this.TABLE_STYLES.bodyText};
    // `;

    // Ultra-compact styles for very small screens
    const baseCellStyle = `
        padding: clamp(10px, 2.5vw, 18px) clamp(6px, 1.5vw, 12px);
        font-size: clamp(13px, 3.2vw, 16px);
        color: ${this.TABLE_STYLES.bodyText};
        vertical-align: middle;
        word-wrap: break-word;
        overflow-wrap: break-word;
        hyphens: auto; /* Enable hyphenation for very long words */
    `;

    // cells.forEach(cellText=>{
    //   const idCell = document.createElement("td");
    //   idCell.style.cssText = baseCellStyle;
    //   idCell.innerText = cellText;

    //   row.appendChild(idCell);
    // });
    // Process cell data for small screens
    const processedCells = cells.map((cell, index) => {
        if (index === 2 && cell.length > 10) { // Date cell
            // Format date for small screens (e.g., "Jan 15" instead of full date)
            return this.formatDateForMobile(cell);
        }
        // if (index === 1 && cell.length > 20) { // Coffee name
        //     // Truncate very long coffee names
        //     return cell.length > 25 ? cell.substring(0, 22) + "..." : cell;
        // }
        return cell;
    });

    processedCells.forEach((cellText, index) => {
      const cell = document.createElement("td");
      cell.style.cssText = baseCellStyle;
      cell.innerText = cellText;
      cell.setAttribute(
        "data-label",
        ["Subscription ID", "Coffee", "Next Shipping", "Action"][index],
      );

      // Add title for truncated text
      if (cells[index] !== cellText) {
        cell.title = cells[index];
      }

      row.appendChild(cell);
    });

    const actionCell = document.createElement("td");
    actionCell.style.cssText = baseCellStyle;

    actionCell.setAttribute("data-label", "Action");

    const actionBtn = document.createElement("button");
    actionBtn.innerText = "Cancel request";
    actionBtn.style.background = "transparent";
    actionBtn.style.border = `1px solid ${this.TABLE_STYLES.buttonBorder}`;
    actionBtn.style.borderRadius = `5px`;
    actionBtn.style.padding = "8px 14px";
    actionBtn.style.cursor = "pointer";
    actionBtn.style.fontWeight = "600";
    actionBtn.style.color = this.TABLE_STYLES.buttonText;
    actionBtn.style.whiteSpace = "nowrap"; // Keep button text on one line
    actionBtn.style.width = "100%"; // Make button full width on mobile
    actionBtn.style.maxWidth = "120px"; // But limit maximum width
    actionBtn.style.minHeight = "36px"; // Touch-friendly minimum height

    actionBtn.onclick = () => {
      this.confirmationModal.open(() => {
        this.cancelSubscriptionRequest(id, cells[0]);
      });
    };

    actionCell.appendChild(actionBtn);

    row.appendChild(actionCell);
    tbody.appendChild(row);
  }

  // Helper method to format dates for mobile
  formatDateForMobile(dateString) {
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;

      // For very small screens, use abbreviated format
      if (window.innerWidth <= 400) {
        const month = date.toLocaleString("default", { month: "short" });
        const day = date.getDate();
        return `${month} ${day}`;
      }

      // For slightly larger screens
      if (window.innerWidth <= 500) {
        const month = date.toLocaleString("default", { month: "short" });
        const day = date.getDate();
        const year = date.getFullYear().toString().slice(-2);
        return `${month} ${day}, '${year}`;
      }

      return dateString;
    } catch (e) {
      return dateString;
    }
  }

  addEmptyRow(content) {
    const tbody = document.querySelector("#subscription-table tbody");
    if (!tbody) return;

    const baseCellStyle = `
      padding: 18px 12px;
      font-size: 16px;
      color: ${this.TABLE_STYLES.bodyText};
      text-align: center;
    `;

    const idCell = document.createElement("td");
    idCell.style.cssText = baseCellStyle;
    idCell.innerText = content ?? "";
    idCell.colSpan = 4;

    const row = document.createElement("tr");
    row.style.borderBottom = `1px solid ${this.TABLE_STYLES.rowBorder}`;
    row.style.backgroundColor = "#fff";

    row.appendChild(idCell);
    tbody.appendChild(row);
  }

  createAndUpdateTable(requestedCoffees) {
    this.createSubscriptionTable("requestedCoffeeTable");

    /**
     * reset existing row of Table
     */
    const tbody = document.querySelector("#subscription-table tbody");
    if (tbody) {
      tbody.innerHTML = "";
    }

    if (requestedCoffees.length === 0) {
      this.addEmptyRow("No coffee request found.");
    } else {
      requestedCoffees?.forEach((row) => {
        this.addSubscriptionRow(
          [
            row.subscriptionId,
            row.coffeeName,
            this.formatToMonthDateYearUTC(row.shippingDate),
          ],
          row.id,
        );
      });
    }
  }

  async cancelSubscriptionRequest(id, subscriptionId) {
    const loader = new loaderCl();
    try {
      loader.showLoader();
      /**
       * removing the requested coffees and
       */
      await fetch(`${this.baseURL}/api/remove-coffee-request`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id,
          subscriptionId,
          customerName: this.customerName,
        }),
      });

      const selectedSubscriptionId = this.subSelectEle?.value || null;

      /**
       * fetch the updated requested coffee list
       */
      await this.fetchCoffeeProfileList(selectedSubscriptionId);
    } catch (error) {
      console.log(error);
      this.showMessage(
        error.message || "Failed to add coffee request",
        "error",
        true,
      );
    } finally {
      loader.hideLoader();
    }
    window.addEventListener("resize", () => {
      this.enableMobileCardLayout();
    });
  }

  enableMobileCardLayout() {
    const container = document.getElementById("subscription-table-container");
    if (!container) return;

    if (window.innerWidth <= 400) {
      container.id = "force-card-layout";
    } else {
      container.id = "subscription-table-container";
    }
  }

  // Enhanced responsive styles for very small screens
  addResponsiveStyles() {
    if (document.getElementById("responsive-table-styles")) return;

    const style = document.createElement("style");
    style.id = "responsive-table-styles";
    style.textContent = `
        /* Hide/show header text based on screen size */
        .header-full {
            display: inline;
        }
        .header-abbr {
            display: none;
        }
        
        /* Ultra Small Screens (under 350px) */
        @media (max-width: 350px) {
            #subscription-table-container {
                min-width: 260px;
                max-height: 350px;
                border-radius: 6px;
                margin: 0 -8px;
                width: calc(100% + 16px);
            }
            
            #subscription-table {
                min-width: 580px;
            }
            
            #subscription-table th,
            #subscription-table td {
                padding: 8px 6px !important;
                font-size: 12px !important;
            }
            
            .header-full {
                display: none;
            }
            .header-abbr {
                display: inline;
            }
            
            #subscription-table th {
                font-size: 11px !important;
                padding: 6px 4px !important;
            }
            
            #subscription-table button {
                min-height: 32px;
                padding: 6px 8px !important;
                font-size: 11px !important;
                max-width: 80px;
            }
        }
        
        /* Very Small Screens (351px - 400px) */
        @media (min-width: 351px) and (max-width: 400px) {
            #subscription-table-container {
                min-width: 280px;
                max-height: 380px;
            }
            
            #subscription-table {
                min-width: 600px;
            }
            
            #subscription-table th,
            #subscription-table td {
                padding: 10px 8px !important;
                font-size: 13px !important;
            }
            
            #subscription-table th {
                font-size: 12px !important;
            }
            
            /* Hide less important columns on very small screens */
            #subscription-table th:nth-child(1),
            #subscription-table td:nth-child(1) {
                display: none;
            }
            
            .header-full {
                display: none;
            }
            .header-abbr {
                display: inline;
            }
        }
        
        /* Small Screens (401px - 500px) */
        @media (min-width: 401px) and (max-width: 500px) {
            #subscription-table-container {
                min-width: 300px;
            }
            
            #subscription-table th,
            #subscription-table td {
                padding: 12px 8px !important;
            }
            
            .header-full {
                display: inline;
            }
            .header-abbr {
                display: none;
            }
        }
        
        /* Card layout alternative for ultra-small screens */
        // @media (max-width: 400px) {
        //     .subscription-card-view {
        //         display: none; /* Initially hidden */
        //     }
            
           
        //     #force-card-layout #subscription-table,
        //     #force-card-layout #subscription-table thead,
        //     #force-card-layout #subscription-table tbody,
        //     #force-card-layout #subscription-table th,
        //     #force-card-layout #subscription-table td,
        //     #force-card-layout #subscription-table tr {
        //         display: block !important;
        //         width: 100% !important;
        //         min-width: 0 !important;
        //     }
            
        //     #force-card-layout #subscription-table thead tr {
        //         position: absolute;
        //         top: -9999px;
        //         left: -9999px;
        //     }
            
        //     #force-card-layout #subscription-table tr {
        //         margin-bottom: 15px;
        //         border: 1px solid #ddd;
        //         border-radius: 8px;
        //         padding: 12px;
        //         display: block !important;
        //         grid-template-columns: 1fr 1fr;
        //         gap: 10px;
        //         background: white;
        //     }
            
        //     #force-card-layout #subscription-table td {
        //         border: none;
        //         border-bottom: 1px solid #eee;
        //         position: relative;
        //         padding-left: 40% !important;
        //         text-align: end;
        //         display: flex;
        //         align-items: center;
        //         min-height: 36px;
        //         padding: 8px !important;   
        //     }
            
        //     #force-card-layout #subscription-table td:nth-child(odd) {
        //         grid-column: 1;
        //     }
            
        //     #force-card-layout #subscription-table td:nth-child(even) {
        //         grid-column: 2;
        //     }
            
        //     #force-card-layout #subscription-table td:last-child {
        //         grid-column: 1 / span 2;
        //         border-bottom: 0;
        //         justify-content: center;
        //         padding-left: 8px !important;
        //     }
            
        //     #force-card-layout #subscription-table td:before {
        //         content: attr(data-label);
        //         position: absolute;
        //         left: 8px;
        //         width: 35%;
        //         padding-right: 8px;
        //         font-weight: bold;
        //         font-size: 12px;
        //         // color: ${this.TABLE_STYLES.headerText};
        //         color:#000;
        //                 text-align: start;
        //     }
            
        //     #force-card-layout #subscription-table td:last-child:before {
        //         display: none;
        //     }
            
        //     #force-card-layout #subscription-table-container {
        //         max-height: none !important;
        //         overflow: visible !important;
        //         min-width: 0 !important;
        //     }
        // }
        
        /* Portrait mode optimization */
        @media (max-height: 500px) and (max-width: 400px) {
            #subscription-table-container {
                max-height: 280px !important;
            }
        }
        
        /* Landscape mode on small screens */
        @media (max-height: 400px) and (orientation: landscape) {
            #subscription-table-container {
                max-height: 250px !important;
            }
            
            #subscription-table th,
            #subscription-table td {
                padding: 6px 4px !important;
                font-size: 11px !important;
            }
        }

        @media (max-width: 767px) {

          body #subscription-table-container {
            max-height: 100% !important;
            box-shadow: none !important;
          }

          body #subscription-table{
            width: 100%;
            min-width: 100% !important;
          } 

          body #subscription-table thead{
              display: none;
          }

          body #subscription-table tbody{
            display: block;
            width: 100%;
          }

          body #subscription-table tbody tr {
            display: block;
            width: 100%;
            overflow: hidden;
            border-radius: 12px;
          }

          body #subscription-table tbody tr:not(:last-child) {
             margin-bottom: 15px;
          }

          #subscription-table th:nth-child(1), #subscription-table td:nth-child(1) {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-radius: 12px 12px 0 0;
          }

          #subscription-table th:nth-child(1), #subscription-table td:last-child {
            border-radius: 0 0 12px 12px;
          }

          body #subscription-table tbody td{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 12px;
            font-size: 14px;
          }

          body #subscription-table tbody td:before {
            content: attr(data-label);
            font-weight: 600;
            color: #666;
            margin-right: 10px;
            white-space: nowrap;
          }

          body div#force-card-layout{
            max-height: 100% !important;
            box-shadow: none !important;
          }
        }
        
        /* Touch device optimizations for very small screens */
        @media (hover: none) and (pointer: coarse) and (max-width: 400px) {
            #subscription-table button {
                min-height: 40px !important;
                min-width: 70px !important;
                padding: 10px !important;
            }
            
            #subscription-table td {
                min-height: 40px !important;
            }
        }
    `;

    document.head.appendChild(style);
  }

  formatToMonthDateYearUTC(isoDateString) {
    const date = new Date(isoDateString);

    return date.toLocaleDateString("en-US", {
      timeZone: "UTC",
      month: "short",
      day: "2-digit",
      year: "numeric",
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new RequestCoffee(baseURL);
});
